import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import SummaryCard from "components/SummaryCard/SummaryCard";
import { Modal } from "reactstrap";
import { put } from "helpers/api_helper";
import * as api from "../../../constants/api_constants";
import { useNavigate } from "react-router-dom";

const FinalRound = ({
  evaluationStatus,
  setEvaluationStatus,
  setActiveRound,
  candidatedetails,
  interviewStageId,
  jobId,
}) => {
  const navigate = useNavigate();
  console.log("jobId",jobId);
  console.log("interviewStageId",interviewStageId);
  
  

  // Helper function to find the finalRoundDto by interviewStageId
  const getRelevantFinalRound = (interviews, stageId) => {
    if (!interviews || interviews.length === 0) {
      return null;
    }

    // First, try to find the finalRoundDto matching the interviewStageId
    const matchingInterview = interviews.find(
      (interview) =>
        interview.interviewStageId === stageId && interview.finalRoundDto
    );

    if (matchingInterview) {
      return matchingInterview.finalRoundDto;
    }

    // Fallback: Select the first finalRoundDto with actual data
    return (
      interviews
        .filter((interview) => interview.finalRoundDto)
        .find((interview) => {
          const { finalRoundDto } = interview;
          return (
            finalRoundDto.currentCTC ||
            finalRoundDto.offeredCTC ||
            finalRoundDto.expectedCTC ||
            finalRoundDto.finalConfirmedCTC ||
            finalRoundDto.notes ||
            finalRoundDto.selectAReasonForDecliningTheOffer?.length > 0 ||
            finalRoundDto.additionalComments
          );
        })?.finalRoundDto ||
      interviews.find((interview) => interview.finalRoundDto)?.finalRoundDto ||
      null
    );
  };

  // Determine the relevant finalRoundDto using interviewStageId
  const relevantFinalRound = getRelevantFinalRound(
    candidatedetails?.job?.[0]?.interviews,
    interviewStageId
  );

  // Determine if the component should be editable
  const isEditable =
    !interviewStageId ||
    (!relevantFinalRound || relevantFinalRound.evaluationOutcome === null);

  const [declineOfferModalOpen, setDeclineOfferModalOpen] = useState(false);
  const [finalRoundDetails, setFinalRoundDetails] = useState({
    currentCTC: relevantFinalRound?.currentCTC || "",
    offeredCTC: relevantFinalRound?.offeredCTC || "",
    expectedCTC: relevantFinalRound?.expectedCTC || "",
    confirmedCTC: relevantFinalRound?.finalConfirmedCTC || "",
    isImmediateJoining: relevantFinalRound?.availableForImmediateJoining || "No",
    noticePeriod: relevantFinalRound?.noticePeriod || "",
    expectedJoiningDate: relevantFinalRound?.expectedDateOfJoining || "",
    willingToRelocate: relevantFinalRound?.candidateWillingToRelocate || "Yes",
    notes: relevantFinalRound?.notes || "",
    declineReasons: {
      acceptedAnotherOffer:
        relevantFinalRound?.selectAReasonForDecliningTheOffer?.includes(
          "Accepted another offer"
        ) || false,
      notSatisfied:
        relevantFinalRound?.selectAReasonForDecliningTheOffer?.includes(
          "Not satisfied with compensation"
        ) || false,
      relocation:
        relevantFinalRound?.selectAReasonForDecliningTheOffer?.includes(
          "Relocation Concern"
        ) || false,
      personal:
        relevantFinalRound?.selectAReasonForDecliningTheOffer?.includes(
          "Personal reasons"
        ) || false,
      others:
        relevantFinalRound?.selectAReasonForDecliningTheOffer?.includes(
          "Others"
        ) || false,
    },
    declineComments: relevantFinalRound?.additionalComments || "",
  });

  // Update state when relevantFinalRound changes
  useEffect(() => {
    if (relevantFinalRound) {
      setFinalRoundDetails({
        currentCTC: relevantFinalRound.currentCTC || "",
        offeredCTC: relevantFinalRound.offeredCTC || "",
        expectedCTC: relevantFinalRound.expectedCTC || "",
        confirmedCTC: relevantFinalRound.finalConfirmedCTC || "",
        isImmediateJoining: relevantFinalRound.availableForImmediateJoining || "No",
        noticePeriod: relevantFinalRound.noticePeriod || "",
        expectedJoiningDate: relevantFinalRound.expectedDateOfJoining || "",
        willingToRelocate: relevantFinalRound.candidateWillingToRelocate || "Yes",
        notes: relevantFinalRound.notes || "",
        declineReasons: {
          acceptedAnotherOffer:
            relevantFinalRound.selectAReasonForDecliningTheOffer?.includes(
              "Accepted another offer"
            ) || false,
          notSatisfied:
            relevantFinalRound.selectAReasonForDecliningTheOffer?.includes(
              "Not satisfied with compensation"
            ) || false,
          relocation:
            relevantFinalRound.selectAReasonForDecliningTheOffer?.includes(
              "Relocation Concern"
            ) || false,
          personal:
            relevantFinalRound.selectAReasonForDecliningTheOffer?.includes(
              "Personal reasons"
            ) || false,
          others:
            relevantFinalRound.selectAReasonForDecliningTheOffer?.includes(
              "Others"
            ) || false,
        },
        declineComments: relevantFinalRound.additionalComments || "",
      });
      const outcome = relevantFinalRound.evaluationOutcome?.toLowerCase();
      setEvaluationStatus(
        outcome === "hired"
          ? "hired"
          : outcome === "put_on_hold"
          ? "hold"
          : outcome === "reject"
          ? "declined offer"
          : evaluationStatus || "in progress"
      );
    }
  }, [relevantFinalRound, setEvaluationStatus]);

  // Debugging logs
  console.log("evaluationStatus", evaluationStatus);
  console.log("finalRoundDetails", finalRoundDetails);
  console.log("relevantFinalRound", relevantFinalRound);
  console.log("isEditable", isEditable);

  // Toggle decline offer modal
  const toggleDeclineOfferModal = () => {
    setDeclineOfferModalOpen(!declineOfferModalOpen);
  };

  // Reset decline reasons and comments
  const resetDeclineData = () => {
    setFinalRoundDetails((prev) => ({
      ...prev,
      declineReasons: {
        acceptedAnotherOffer: false,
        notSatisfied: false,
        relocation: false,
        personal: false,
        others: false,
      },
      declineComments: "",
    }));
  };

  // Handle input changes for text, select, and checkbox
  const handleInputChange = (field, value) => {
    if (isEditable) {
      setFinalRoundDetails((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  // Handle decline reasons checkbox changes
  const handleCheckboxChange = (key) => {
    if (isEditable) {
      setFinalRoundDetails((prev) => ({
        ...prev,
        declineReasons: {
          ...prev.declineReasons,
          [key]: !prev.declineReasons[key],
        },
      }));
    }
  };

  // Handle evaluation status change and submit to backend
  const handleEvaluationStatusChange = async (status) => {
    if (!isEditable) return;

    if (evaluationStatus === "declined offer" && status !== "declined offer") {
      resetDeclineData();
    }
    setEvaluationStatus(status);

    const evaluationOutcomeMap = {
      hired: "Hired",
      hold: "Hold",
      "declined offer": "Declined offer",
      
    };

    const evaluationOutcome = evaluationOutcomeMap[status] || "IN_PROGRESS";

    // Map decline reasons to API format
    const declineReasonsArray = Object.entries(
      finalRoundDetails.declineReasons
    )
      .filter(([_, value]) => value)
      .map(([key]) => {
        const reasonMap = {
          acceptedAnotherOffer: "Accepted another offer",
          notSatisfied: "Not satisfied with compensation",
          relocation: "Relocation Concern",
          personal: "Personal reasons",
          others: "Others",
        };
        return reasonMap[key];
      });

    // Construct payload for API

    const payload = {
      delFlag: 1,
      jobId: jobId,
      candidateId: candidatedetails?.id,
      finalRoundDto: {
        currentCTC: finalRoundDetails.currentCTC || "",
        offeredCTC: finalRoundDetails.offeredCTC || "",
        expectedCTC: finalRoundDetails.expectedCTC || "",
        finalConfirmedCTC: finalRoundDetails.confirmedCTC || "",
        availableForImmediateJoining: finalRoundDetails.isImmediateJoining,
        noticePeriod:
          finalRoundDetails.isImmediateJoining === "No"
            ? finalRoundDetails.noticePeriod
            : "",
        expectedDateOfJoining: finalRoundDetails.expectedJoiningDate || "",
        candidateWillingToRelocate: finalRoundDetails.willingToRelocate,
        notes: finalRoundDetails.notes.trim() || "",
        selectAReasonForDecliningTheOffer:
          status === "declined offer" ? declineReasonsArray : [],
        additionalComments:
          status === "declined offer" ? finalRoundDetails.declineComments : "",
        evaluationOutcome,
        roundType:"Final Round"
      },
    };

    try {
      const interviewId =
        interviewStageId ||
        relevantFinalRound?.finalRoundId ||
        candidatedetails?.job?.[0]?.interviews?.find(
          (interview) => interview.finalRoundDto
        )?.interviewStageId;
      if (!interviewId) {
        throw new Error("Interview ID is not available");
      }
      const response = await put(api.UPDATE_INTERVIEWS_BY_ID(interviewId), payload);
      console.log("Final round updated successfully:", response);

      if (status === "hired") {
        setActiveRound("completed");
      } else if (status === "hold" || status === "declined offer") {
        navigate(`/job-details/${jobId}`);
      }
    } catch (error) {
      console.error("Failed to update final round data:", error);
    }
  };

  // Determine if "Hired" button should be disabled
  const isHiredDisabled = () => {
    return (
      !isEditable ||
      evaluationStatus === "rejected" ||
      evaluationStatus === "hold" ||
      evaluationStatus === "declined offer"
    );
  };

  return (
    <div>
      <Container fluid className="py-4 px-4">
        <Row>
          {/* Salary Negotiations */}
          <SummaryCard title="Salary Negotiations">
            <Row>
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Current CTC</Label>
                  <Input
                    name="currentCTC"
                    type="text"
                    value={finalRoundDetails.currentCTC}
                    onChange={(e) => handleInputChange("currentCTC", e.target.value)}
                    disabled={!isEditable}
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                    placeholder="Current CTC"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Offered CTC</Label>
                  <Input
                    name="offeredCTC"
                    type="text"
                    value={finalRoundDetails.offeredCTC}
                    onChange={(e) => handleInputChange("offeredCTC", e.target.value)}
                    disabled={!isEditable}
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                    placeholder="Offered CTC"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Expected CTC</Label>
                  <Input
                    name="expectedCTC"
                    type="text"
                    value={finalRoundDetails.expectedCTC}
                    onChange={(e) => handleInputChange("expectedCTC", e.target.value)}
                    disabled={!isEditable}
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                    placeholder="Expected CTC"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Final Confirmed CTC</Label>
                  <Input
                    name="confirmedCTC"
                    type="text"
                    value={finalRoundDetails.confirmedCTC}
                    onChange={(e) => handleInputChange("confirmedCTC", e.target.value)}
                    disabled={!isEditable}
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                    placeholder="Confirmed CTC"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Available for Immediate Joining?</Label>
                  <Input
                    type="select"
                    name="isImmediateJoining"
                    className="form-select"
                    id="isImmediateJoining"
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                    value={finalRoundDetails.isImmediateJoining}
                    onChange={(e) => handleInputChange("isImmediateJoining", e.target.value)}
                    disabled={!isEditable}
                  >
                    <option>Yes</option>
                    <option>No</option>
                  </Input>
                </FormGroup>
              </Col>
              {finalRoundDetails.isImmediateJoining === "No" && (
                <Col md={3}>
                  <FormGroup className="mb-3">
                    <Label>Notice Period</Label>
                    <Input
                      name="noticePeriod"
                      type="text"
                      value={finalRoundDetails.noticePeriod}
                      onChange={(e) => handleInputChange("noticePeriod", e.target.value)}
                      disabled={!isEditable}
                      style={{
                        border: "2px solid #E3E8EE",
                        height: "60px",
                        borderRadius: "12px",
                      }}
                      placeholder="Notice Period"
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Expected Date of Joining</Label>
                  <Input
                    name="expectedJoiningDate"
                    type="date"
                    value={finalRoundDetails.expectedJoiningDate}
                    onChange={(e) => handleInputChange("expectedJoiningDate", e.target.value)}
                    disabled={!isEditable}
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3} />
              <Col md={3}>
                <FormGroup className="mb-3">
                  <Label>Candidate willing to relocate</Label>
                  <Input
                    type="select"
                    name="willingToRelocate"
                    className="form-select"
                    id="willingToRelocate"
                    style={{
                      border: "2px solid #E3E8EE",
                      height: "60px",
                      borderRadius: "12px",
                    }}
                    value={finalRoundDetails.willingToRelocate}
                    onChange={(e) => handleInputChange("willingToRelocate", e.target.value)}
                    disabled={!isEditable}
                  >
                    <option>Yes</option>
                    <option>No</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            </SummaryCard>
            {/* Notes */}
            <SummaryCard title="Notes">
              <FormGroup className="mb-3">
                <Input
                  name="notes"
                  type="textarea"
                  value={finalRoundDetails.notes}
                  onChange={(e) => handleInputChange("notes", e.target.value)}
                  disabled={!isEditable}
                  style={{
                    border: "2px solid #E3E8EE",
                    height: "100px",
                    borderRadius: "12px",
                  }}
                  placeholder="Add Note..."
                />
              </FormGroup>
            </SummaryCard>
            {/* Evaluation Outcome */}
            <SummaryCard title="Evaluation Outcome">
              <Row>
                <Col>
                  <Button
                    onClick={() => handleEvaluationStatusChange("hold")}
                    disabled={!isEditable}
                    style={{
                      paddingRight: "20px",
                      paddingLeft: "20px",
                      height: "40px",
                      borderRadius: "12px",
                      marginRight: "10px",
                      backgroundColor: "#1E9EFB",
                      color: "white",
                      border: evaluationStatus === "hold" ? "2px solid #000" : "none",
                    }}
                  >
                    Put On Hold
                  </Button>
                  <Button
                    onClick={toggleDeclineOfferModal}
                    disabled={!isEditable}
                    style={{
                      paddingRight: "10px",
                      paddingLeft: "10px",
                      height: "40px",
                      borderRadius: "12px",
                      marginRight: "10px",
                      backgroundColor: "#F93131",
                      color: "white",
                      border:
                        evaluationStatus === "declined offer" ? "2px solid #000" : "none",
                    }}
                  >
                    Decline Offer Letter
                  </Button>
                  <Button
                    onClick={() => handleEvaluationStatusChange("hired")}
                    disabled={isHiredDisabled()}
                    style={{
                      paddingRight: "20px",
                      paddingLeft: "20px",
                      height: "40px",
                      borderRadius: "12px",
                      marginRight: "10px",
                      backgroundColor: "#006438",
                      color: "white",
                      border: evaluationStatus === "hired" ? "2px solid #000" : "none",
                    }}
                  >
                    Mark as Hired
                  </Button>
                </Col>
              </Row>
            </SummaryCard>
            {/* Decline Offer Modal */}
            <Modal
              isOpen={declineOfferModalOpen}
              toggle={toggleDeclineOfferModal}
              style={{
                maxWidth: "640px",
                height: "563px",
                marginTop: "101px",
                borderRadius: "32px",
                gap: "24px",
                backgroundColor: "white",
              }}
              contentClassName="custom-modal-content"
            >
              <h4 className="text-black m-3">Declined Offer</h4>
              <Row className="mx-2 text-black">
                <h6 className="mb-3">Select a reason for Declining the offer</h6>
                <Col>
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={finalRoundDetails.declineReasons.acceptedAnotherOffer}
                        onChange={() => handleCheckboxChange("acceptedAnotherOffer")}
                        disabled={!isEditable}
                        style={{
                          transform: "scale(1.5)",
                          marginRight: "8px",
                          cursor: "pointer",
                          borderColor: "black",
                        }}
                      />
                      Accepted another offer
                    </Label>
                  </FormGroup>
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={finalRoundDetails.declineReasons.notSatisfied}
                        onChange={() => handleCheckboxChange("notSatisfied")}
                        disabled={!isEditable}
                        style={{
                          transform: "scale(1.5)",
                          marginRight: "8px",
                          cursor: "pointer",
                          borderColor: "black",
                        }}
                      />
                      Not satisfied with compensation
                    </Label>
                  </FormGroup>
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={finalRoundDetails.declineReasons.relocation}
                        onChange={() => handleCheckboxChange("relocation")}
                        disabled={!isEditable}
                        style={{
                          transform: "scale(1.5)",
                          marginRight: "8px",
                          cursor: "pointer",
                          borderColor: "black",
                        }}
                      />
                      Relocation concerns
                    </Label>
                  </FormGroup>
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={finalRoundDetails.declineReasons.personal}
                        onChange={() => handleCheckboxChange("personal")}
                        disabled={!isEditable}
                        style={{
                          transform: "scale(1.5)",
                          marginRight: "8px",
                          cursor: "pointer",
                          borderColor: "black",
                        }}
                      />
                      Personal reasons
                    </Label>
                  </FormGroup>
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={finalRoundDetails.declineReasons.others}
                        onChange={() => handleCheckboxChange("others")}
                        disabled={!isEditable}
                        style={{
                          transform: "scale(1.5)",
                          marginRight: "8px",
                          cursor: "pointer",
                          borderColor: "black",
                        }}
                      />
                      Others
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mx-2 text-black">
                <p className="mb-0">Additional Comments</p>
                <i style={{ fontSize: "12px" }}>
                  This will be visible to HR/recruitment team for future reference
                </i>
                <FormGroup className="my-3">
                  <Row className="align-items-center">
                    <Col>
                      <Input
                        name="declineComments"
                        type="text"
                        value={finalRoundDetails.declineComments}
                        onChange={(e) => handleInputChange("declineComments", e.target.value)}
                        disabled={!isEditable}
                        style={{
                          border: "2px solid #E3E8EE",
                          height: "60px",
                          borderRadius: "12px",
                        }}
                        placeholder="Comments"
                      />
                    </Col>
                  </Row>
                </FormGroup>
                <Row className="mt-2">
                  <Col className="d-flex justify-content-end">
                    <Button
                      className="me-1"
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        width: "128px",
                        height: "40px",
                        borderRadius: "12px",
                      }}
                      onClick={() => {
                        resetDeclineData();
                        toggleDeclineOfferModal();
                      }}
                      disabled={!isEditable}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{
                        backgroundColor: "#006438",
                        color: "white",
                        width: "128px",
                        height: "40px",
                        borderRadius: "12px",
                      }}
                      onClick={() => {
                        handleEvaluationStatusChange("declined offer");
                        toggleDeclineOfferModal();
                      }}
                      disabled={!isEditable}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Row>
            </Modal>
          </Row>
        </Container>
      </div>
    );
};

export default FinalRound;